document.addEventListener('DOMContentLoaded', () => {
  const isSwedish = document.documentElement.lang.toLowerCase().startsWith('sv');
  const productSuffix = isSwedish ? '-se' : '';
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  menuToggle?.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(isOpen));
  });

  document.querySelector('[data-text-size]')?.addEventListener('click', () => {
    document.documentElement.classList.toggle('text-large');
  });

  document.querySelector('[data-contrast]')?.addEventListener('click', () => {
    document.documentElement.classList.toggle('contrast');
  });

  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('input[type="number"]');
    const minimum = Number(input?.min || 1);

    const updateQuantity = (change) => {
      if (!input) return;
      const current = Number(input.value) || minimum;
      input.value = String(Math.max(minimum, current + change));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    selector.querySelector('[data-quantity-minus]')?.addEventListener('click', () => updateQuantity(-1));
    selector.querySelector('[data-quantity-plus]')?.addEventListener('click', () => updateQuantity(1));
    input?.addEventListener('change', () => {
      input.value = String(Math.max(minimum, Number(input.value) || minimum));
    });
  });

  document.querySelectorAll('[data-free-shipping]').forEach((progress) => {
    const threshold = Number(progress.dataset.threshold || 3);
    const baseCount = Number(progress.dataset.baseCount || 0);
    const bar = progress.querySelector('[data-shipping-bar]');
    const message = progress.querySelector('[data-shipping-message]');
    const quantityInput = progress.dataset.quantityInput ? document.getElementById(progress.dataset.quantityInput) : null;
    const cartQuantityInputs = [...document.querySelectorAll('[data-cart-quantity]')];

    const updateProgress = () => {
      let itemCount = baseCount;
      if (quantityInput) {
        itemCount += Math.max(1, Number(quantityInput.value) || 1);
      } else if (cartQuantityInputs.length) {
        itemCount = cartQuantityInputs.reduce((total, input) => total + Math.max(0, Number(input.value) || 0), 0);
      }

      const remaining = Math.max(0, threshold - itemCount);
      if (bar) bar.value = Math.min(itemCount, threshold);
      if (!message) return;
      if (remaining === 0) message.textContent = isSwedish ? 'Du har fri frakt.' : 'Du har fri levering.';
      else if (remaining === 1) message.textContent = isSwedish ? 'Lägg till 1 produkt till för fri frakt.' : 'Tilføj 1 produkt mere for fri levering.';
      else message.textContent = isSwedish ? `Lägg till ${remaining} produkter till för fri frakt.` : `Tilføj ${remaining} produkter mere for fri levering.`;
    };

    quantityInput?.addEventListener('input', updateProgress);
    cartQuantityInputs.forEach((input) => {
      input.addEventListener('input', updateProgress);
      input.addEventListener('change', updateProgress);
    });
    updateProgress();
  });

  document.querySelectorAll('[data-quiz-shell]').forEach((shell) => {
    const form = shell.querySelector('[data-quiz]');
    const steps = [...shell.querySelectorAll('[data-quiz-step]')];
    const backButton = shell.querySelector('[data-quiz-back]');
    const progressText = shell.querySelector('[data-quiz-progress]');
    const progressBar = shell.querySelector('[data-quiz-progress-bar]');
    const error = shell.querySelector('[data-quiz-error]');
    const resultContainer = shell.querySelector('[data-quiz-result]');
    let currentStep = 0;

    const recommendations = {
      rejuvenate: {
        product: 'Femarelle Rejuvenate',
        handle: `femarelle-rejuvenate${productSuffix}`,
        reason: isSwedish ? 'Passar bäst vid humörsvängningar, oro eller irritabilitet, trötthet samt förändringar i hud och hår.' : 'Passer bedst til humørsvingninger, uro eller irritabilitet, træthed samt ændringer i hud og hår.'
      },
      recharge: {
        product: 'Femarelle Recharge',
        handle: `femarelle-recharge${productSuffix}`,
        reason: isSwedish ? 'Passar bäst vid värmevallningar, nattliga svettningar, sömnstörningar eller minskad sexlust.' : 'Passer bedst til hedeture, nattesved, søvnforstyrrelser eller nedsat sexlyst.'
      },
      unstoppable: {
        product: 'Femarelle Unstoppable',
        handle: `femarelle-unstoppable${productSuffix}`,
        reason: isSwedish ? 'Passar bäst som stöd för benstomme, vaginalt välbefinnande, leder och muskler samt energi.' : 'Passer bedst til støtte for knogler, vaginalt velvære, led og muskler samt energi.'
      }
    };

    const showStep = (index, moveFocus = true) => {
      currentStep = index;
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== currentStep; });
      backButton.hidden = currentStep === 0;
      progressText.textContent = isSwedish ? `Steg ${currentStep + 1} av ${steps.length}` : `Trin ${currentStep + 1} af ${steps.length}`;
      progressBar.value = currentStep + 1;
      error.hidden = true;
      if (moveFocus) steps[currentStep].querySelector('legend')?.focus({ preventScroll: false });
    };

    backButton?.addEventListener('click', () => {
      steps[currentStep].querySelectorAll('input').forEach((input) => { input.checked = false; });
      showStep(currentStep - 1);
    });

    const showResult = () => {
      const scores = { rejuvenate: 0, recharge: 0, unstoppable: 0 };
      form.querySelectorAll('input:checked').forEach((input) => {
        if (scores[input.value] !== undefined) scores[input.value] += input.name === 'priority' ? 2 : 1;
      });
      const symptomGroup = Object.keys(scores).sort((a, b) => scores[b] - scores[a])[0];
      const recommendation = recommendations[symptomGroup];
      if (!recommendation || !resultContainer) return;

      form.hidden = true;
      shell.querySelector('.quiz-progress').hidden = true;
      resultContainer.innerHTML = `
        <div class="quiz-result-card">
          <span class="eyebrow">${isSwedish ? 'Ditt förslag' : 'Dit forslag'}</span>
          <h3>${recommendation.product}</h3>
          <p>${recommendation.reason}</p>
          <p class="quiz-disclaimer">${isSwedish ? 'Detta är en allmän produktvägledning och inte medicinsk rådgivning.' : 'Dette er en generel produktvejledning og ikke medicinsk rådgivning.'}</p>
          <div class="button-row"><a class="btn" href="/products/${recommendation.handle}">${isSwedish ? 'Se produkten' : 'Se produktet'}</a><button class="btn btn-outline" type="button" data-quiz-restart>${isSwedish ? 'Börja om' : 'Start forfra'}</button></div>
        </div>`;
      resultContainer.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
        form.reset();
        form.hidden = false;
        shell.querySelector('.quiz-progress').hidden = false;
        resultContainer.innerHTML = '';
        showStep(0);
      });
      resultContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    form?.addEventListener('change', (event) => {
      if (!event.target.matches('input') || !event.target.checked) return;
      error.hidden = true;
      window.setTimeout(() => {
        if (currentStep < steps.length - 1) {
          showStep(currentStep + 1);
        } else {
          showResult();
        }
      }, 180);
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (steps[currentStep].querySelector('input:checked')) showResult();
    });

    showStep(0, false);
  });

  document.querySelectorAll('[data-faq-source]').forEach((source) => {
    const questions = [...source.querySelectorAll('h3')];
    questions.forEach((question) => {
      const details = document.createElement('details');
      details.className = 'faq-item';
      const summary = document.createElement('summary');
      summary.textContent = question.textContent;
      details.append(summary);
      const answer = question.nextElementSibling;
      if (answer && answer.tagName !== 'H3') details.append(answer);
      question.replaceWith(details);
    });
  });
});
